import { VideoJsAudioPlayer } from '@app/core/playback/audio/VideoJsAudioPlayer';
import { VideoJsPlaybackProvider } from '@app/core/playback/video/VideoPlaybackProvider';
import { toTimestamp } from '@mi-front/core';
import { useFragment } from '../../../hooks/useFragment';
import { AudioFragmentChunksPills } from './AudioFragmentChunksPills';

/**
 * Main component that renders a single VideoJS-based audio player for fragments.
 * It wires `VideoPlaybackProvider` so the transcription panel can sync against playback time.
 */
export function AudioFragmentMedia() {
  const { fragment } = useFragment();
  const audioUrl = fragment.assets.audio?.url;
  const chunks = fragment.chunks ?? [];
  const showChunkPills = chunks.length > 1;
  /** Sum of chunk durations (ms); used for pill widths so layout matches chunk metadata, not fragment from/to. */
  const fragmentDurationMs = chunks.reduce((sum, c) => sum + c.duration, 0);

  if (!audioUrl) {
    return null;
  }

  return (
    <VideoJsPlaybackProvider
      src={audioUrl}
      playbackRange={{ from: toTimestamp(fragment.from), to: toTimestamp(fragment.to) }}
    >
      <VideoJsAudioPlayer size="large" />
      {showChunkPills && (
        <AudioFragmentChunksPills chunks={chunks} fragmentDurationMs={fragmentDurationMs} />
      )}
    </VideoJsPlaybackProvider>
  );
}
